import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useLanguage } from '@/shared/lib/hooks';

import { useGetDisclamersContentQuery } from '../../api/disclamers.api';

import cls from './trading-journal-disclamer.module.css';

export const TradingJournalDisclamer = memo(() => {
    const [language] = useLanguage();
    const { t } = useTranslation('translation');

    const { data } = useGetDisclamersContentQuery({
        locale: language,
    });

    if (!data?.tradingJournal) return null;

    return (
        <div className={cls.root}>
            <h2 className={cls.title}>{t('disclamer')}</h2>
            <div className={cls.content}>{data.tradingJournal}</div>
        </div>
    );
});

TradingJournalDisclamer.displayName = 'TradingJournalDisclamer';
